import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist'

import login from './modules/login';
import user from './modules/user';
import structure from './modules/structure';
import device from './modules/device';
import dashboardFilter from "./modules/dashboardFilter";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const vuexPersist = new VuexPersist({
  key: 'lorameter',
  storage: localStorage,
  reducer: (state) => ({
    user: {
      authTokens: state.user.authTokens
    }
  })
});

export default new Vuex.Store({
  modules: {
    login,
    user,
    structure,
    device,
    dashboardFilter
  },
  strict: debug,
  plugins: [vuexPersist.plugin]
})
